import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Table, Form, Row, Col, Button, Input, Select, DatePicker, InputNumber, Popconfirm, Typography, message, Pagination } from 'antd';
import moment from 'moment';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { getOrderPlanTask, modifyOrderPlanTask } from './api';
import CpProductInfo from '../../components/CpProductInfo';
import { amountToString } from '../../util/tool';
import { formItemLayout3 as formItemLayout } from '../../util/formItemLayoutConfig';
import { queryString } from '../../util/qs';
import './style.less';

const { Option } = Select;
const { RangePicker } = DatePicker;
const showNumber = 3;
const emptyText = '无预订商品';

const statusIndexToText = {
  "-1": "全部",
  "0": "未预订",
  "1": "可预订",
  "2": "不可预订"
};

const submitStatus = {
  0: '未预订',
  1: "已预订",
  2: "已取消"
};
const planStatusText = {
  1: "可预订",
  2: '不可预订'
};

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = <InputNumber min={0} precision={0} />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[{ required: dataIndex !== 'sub_code', message: `请输入${title}!`, }]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
export default function ErpList() {
  const history = useHistory();
  const [searchForm] = Form.useForm();
  const [form] = Form.useForm();
  const [list, setList] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [totalPage, setTotalPage] = useState(1);
  const [pageConfig, setPageConfig] = useState({ page: 1, limit: 20 });

  useEffect(() => {
    async function getOrderPlanTaskList() {
      const { dateRange = [], supplierName, supplierCode, taskName, taskNo, status = -1 } = searchForm.getFieldsValue();
      const [startTime, endTime] = dateRange.map(item => moment(item).format('YYYY-MM-DD'));
      const baseParams = {
        order_no: taskNo,
        task_name: taskName,
        supplier_name: supplierName,
        tripartite_code: supplierCode,
        task_start_time: startTime,
        task_end_time: endTime,
        type: 2
      };

      const params = +status === -1 ? baseParams : { ...baseParams, submit_op: status };
      const { data: { code, msg, data } } = await getOrderPlanTask({ ...params, ...pageConfig });
      if (+code === 0) {
        const { data: list = [], total } = data;
        const formatList = list.map(item => ({ ...item, isExpand: true }));
        setList(formatList);
        setTotalPage(total);
      } else {
        message.error(msg);
      }
    }
    getOrderPlanTaskList();
  }, [pageConfig, searchForm]);

  const handleQuery = () => {
    setPageConfig({ ...pageConfig, page: 1 });
  };

  const reset = () => {
    searchForm.resetFields();
    setPageConfig({ ...pageConfig, page: 1 });
  };

  // const toReportedList = () => {
  //   history.push('/basic/user/prePlanReport/reportedList');
  // };
  const createUniqueKey = record => `${record.order_no}-${record.id}`;
  const tablePageChange = (page, pageSize) => { setPageConfig({ ...pageConfig, page }); };
  const isEditing = record => createUniqueKey(record) === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      name: '',
      age: '',
      address: '',
      ...record,
    });
    setEditingKey(createUniqueKey(record));
  };

  const cancel = () => { setEditingKey(''); };

  const save = async (uniqueKey) => {
    try {
      const row = await form.validateFields();
      const newData = [...list];
      const [key, subKey] = uniqueKey.split('-');
      const index = newData.findIndex((item) => key === item.order_no);
      const item = newData[index];
      const current = newData[index].submit || [];
      const subIndex = current.findIndex(item => +subKey === item.id);
      if (index > -1) {
        const currentItem = current[subIndex];
        const modifyItem = { ...currentItem, ...row };
        const { id: submit_id, submit_number, submit_status } = modifyItem;
        // 预订前要保证需求量有值
        if (submit_status === 1 && submit_number <= 0) {
          message.info('请先填写需求数量');
          return;
        }
        const { data: { code, msg } } = await modifyOrderPlanTask({ submit_id, submit_number, submit_status });
        if (+code === 0) {
          message.success(msg);
          current.splice(subIndex, 1, modifyItem);
          newData.splice(index, 1, { ...item, ...currentItem });
          setList(newData);
          setEditingKey('');
        } else {
          message.error(msg);
        }
      } else {
        newData.push(row);
        setList(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };
  const columns = [
    {
      title: '商品信息',
      dataIndex: 'goods',
      key: 'goods',
      align: 'center',
      render: (text, record) => <CpProductInfo product={text} toProductDetail={() => {
        const { tripartite_code: supplierId } = record;
        const { sale_no: sale_id, } = text;
        const norms_id = 1;
        history.push('/basic/product/detail/' + sale_id + '/' + supplierId + '/' + norms_id);
      }} />
    },
    {
      title: '商品价格',
      dataIndex: 'sale_price',
      key: 'sale_price',
      align: 'center',
      render: (_, record) => amountToString(record?.goods?.sale_price || 0)
    },
    {
      title: '预订数量', // 预订收集开始日期
      dataIndex: 'submit_number',
      key: 'submit_number',
      align: 'center',
      editable: true
    },
    {
      title: '所属SVC',
      dataIndex: 'svc_name',
      key: 'svc_name',
      align: 'center',
    },
    {
      title: '需求区域',
      dataIndex: 'area',
      key: 'area',
      align: 'center',
      render: (text, record) => {
        return <span>{record.province_name + '-' + record.city_name}</span>;
      }
    },
    {
      title: '状态',
      dataIndex: 'submit_status',
      key: 'submit_status',
      align: 'center',
      render: (text) => submitStatus[text]
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 150,
      render: (_, record) => {
        const { submit_status, submit_op } = record;
        const editable = isEditing(record);
        // 已预订（1） ｜｜ 预订状态不为1， 不可编辑
        return <>
          {
            submit_op === 2 ? '-' :
              <>
                {
                  // !((submit_status === 1) || (submit_op !== 1)) ? <>
                  !(submit_status === 1) ? <>
                    {
                      editable ? <span>
                        <Typography.Link onClick={() => save(createUniqueKey(record))} style={{ marginRight: 8 }}>保存</Typography.Link>
                        <span onClick={cancel}>取消</span>
                      </span> :
                        <>
                          <Typography.Link style={{ marginRight: 8 }} onClick={() => edit(record)}>编辑</Typography.Link>
                          <Typography.Link onClick={() => handleSubmit(record, 1)}>
                            <span>预订</span>
                          </Typography.Link>
                        </>
                    }
                  </> :
                    <Popconfirm title=" 确定取消预订?" onConfirm={() => handleSubmit(record, 2)}>
                      <Typography.Link>
                        <span>取消预订</span>
                      </Typography.Link>
                    </Popconfirm>
                }
              </>
          }
        </>;
      },
    },
  ];


  const handleSubmit = async (record, status) => {
    const { id, submit_number } = record;

    // 预订前要保证需求量有值
    if (status === 1 && submit_number <= 0) {
      message.info('请先填写需求数量');
      return;
    }
    const data = {
      submit_id: id,
      submit_status: status,
      submit_number,
    };
    const { data: { code, msg } } = await modifyOrderPlanTask(data);
    if (+code === 0) {
      message.success(msg);
      setPageConfig({ ...pageConfig, page: 1 });
    } else {
      message.error(msg);
    }
  };
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const expandFn = (info = {}) => {
    const { order_no } = info;
    const newList = list.map(item => item.order_no === order_no ? ({ ...item, isExpand: !item.isExpand }) : item);
    setList(newList);
  };

  // const selectProducts = (item = {}) => {
  //   const { order_no, supplier_name, tripartite_code } = item;
  //   history.push(`/basic/user/prePlanReport/select/${order_no}/${supplier_name}/${tripartite_code}`);
  // }

  const transferToOrder = (item = {}) => {
    const { order_no } = item;
    history.push(`/basic/transfer/order?${queryString({ orderId: order_no })}`);
  };

  const header = (item => {
    const { order_no, plan_start_time, plan_end_time, task_start_time, task_end_time, submit_op, release_time } = item;
    return <div className='pre-list-top'>
      <div className='plan-list-item-actions'>
        {item.to_order_status === 1 ? <span onClick={() => transferToOrder(item)}>预售转订单</span> : null}
        {/* {item.submit_op !== 2 ? <span onClick={() => selectProducts(item)}>添加商品</span> : null} */}
      </div>
      <div className='plan-list-explain'>
        <Row>
          <Col span={8}>预售单编号：{order_no}</Col>
          <Col span={8}>预售发布日期：{release_time}</Col>
          <Col span={8}>采购开始日期：{plan_start_time}</Col>
        </Row>
        <Row>
          {/* <Col span={8}>预售名称：{task_name}</Col> */}
          <Col span={8}>预售收集开始日期：{task_start_time}</Col>
          <Col span={8}>预售状态：{planStatusText[submit_op]}</Col>
          <Col span={8}>采购结束日期：{plan_end_time}</Col>
        </Row>
        <Row>
          {/* <Col span={8}>预售类型：{typeText[type]}</Col> */}
          <Col span={8}>预售收集结束日期{task_end_time}</Col>
        </Row>
      </div>
    </div>;
  });

  return (
    <div className='pre-plan-list'>
      <div className="title">预售订单</div>
      <div style={{ margin: '20px 0' }}>
        <Form
          form={searchForm}
          {...formItemLayout}
          onFinish={handleQuery}
        >
          <Row>
            <Col span={8}>
              <Form.Item label='预售日期' name="dateRange">
                <RangePicker format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='供应商公司' name="supplierName">
                <Input maxLength={100} placeholder='请输入供应商公司名称' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='供应商编码' name="supplierCode">
                <Input maxLength={100} placeholder='请输入供应商编码' />
              </Form.Item>
            </Col>
            {/* <Col span={8}>
              <Form.Item label='预售名称' name="taskName">
                <Input maxLength={100} placeholder='请输入预售名称' />
              </Form.Item>
            </Col> */}
            <Col span={8}>
              <Form.Item label='预售单编号' name="taskNo">
                <Input maxLength={100} placeholder='请输入预售单编号' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='预售状态' name="status">
                <Select placeholder='请选择预售状态'>
                  {Reflect.ownKeys(statusIndexToText).sort().filter(item => +item !== 0).map(obj => <Option key={obj} value={obj}>{statusIndexToText[obj]}</Option>)}
                </Select>
              </Form.Item>
            </Col>
            {/* <Col span={8}>
              <Form.Item label='预售类型' name="type">
                <Select placeholder='请选择预售类型'>
                  {Reflect.ownKeys(typeText).sort().map(item => <Option key={item} value={item}>{typeText[item]}</Option>)}
                </Select>
              </Form.Item>
            </Col> */}
            <Col span={8} offset={16} style={{ textAlign: 'right' }}>
              <Button type='primary' htmlType='submit'>查询</Button>
              <Button style={{ marginLeft: 8 }} onClick={reset}>重置</Button>
              {/* <Button style={{ marginLeft: 8 }} type='primary' onClick={toReportedList}>已预订预订查询</Button> */}
            </Col>
          </Row>
        </Form>
      </div>
      {
        (list || []).length ? (list || []).map(item => {
          return <div key={item.id} className='plan-list-item-container'>
            <Form form={form} component={false} >
              <Table
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                locale={{ emptyText }}
                title={() => header(item)}
                dataSource={((item?.submit || []).map(sItem => ({ ...sItem, submit_op: item.submit_op, tripartite_code: item.tripartite_code })) || []).slice(0, item.isExpand ? showNumber : item.submit.length)}
                columns={mergedColumns}
                rowClassName="editable-row"
                rowKey='id'
                pagination={false}
              />
            </Form>
            {item.submit.length > showNumber ?
              <div className='plan-list-item-expand pointer' onClick={() => expandFn(item)}>
                {item.isExpand ? <span><span>共<Typography.Link>{item.submit.length}</Typography.Link>种商品，查看全部</span><DownOutlined /></span> : <span><span>收起</span><UpOutlined /></span>}
              </div> : null}
          </div>;
        }) :
          <Table
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            locale={{ emptyText }}
            // bordered
            dataSource={[]}
            columns={mergedColumns}
            rowClassName="editable-row"
            rowKey='id'
            pagination={false}
          />
      }
      <div className='pagination'>
        <Pagination
          {...{
            current: Number(pageConfig.page || 1),
            total: Number(totalPage || 1),
            pageSize: pageConfig.limit,
            onChange: tablePageChange
          }}
        />
      </div>
    </div>
  );
};